
import { API, graphqlOperation } from 'aws-amplify'
import Lambda from 'aws-sdk/clients/lambda'
import { Auth } from 'aws-amplify'
import { sub, getTime } from 'date-fns'
import { capitalizeEachWord } from '../../../../lib/stringOperations'

const updateOccupant = `mutation updateOccupant($pk: ID!, $sk: String!, $version: Int!,  $input: updateOccupantInput) {
    updateOccupant(pk: $pk, sk: $sk, expectedVersion: $version, input: $input) {
        pk
        sk
        d1
        d2
        firstName
        lastName
        email
        lastLogin
        version
        primaryContact
        registrationDate
        roles
        metaData {
            createdAt
        }
        phone {
            number
        }
        workPhone {
            number
            extension
        }
        extraFields {
            key
            value
        }
        version
    }
}`

const updateTraining = `
    mutation UpdateTrainingResult(
        $expectedVersion: Int!
        $input: updateTrainingResultInput
        $pk: ID!
        $sk: String!
    ) {
    updateTrainingResult(
        expectedVersion: $expectedVersion
        input: $input
        pk: $pk
        sk: $sk
    ) {
        certificateType
        completedAt
        createdAt
        d1
        d2
        firstName
        lastName
        pk
        quizzesCompleted
        sk
        title {
            language
            text
        }
        updatedAt
        userType
        version
        videosCompleted
    }
}`

const deleteOccupant = `mutation deleteOccupant($pk: ID!, $sk: String) {
    deleteOccupant(pk: $pk, sk: $sk) {
        pk
        sk
        d1
        d2
        firstName
        lastName
        email
        lastLogin
        version
        primaryContact
        roles
        phone {
            number
        }
        workPhone {
            number
            extension
        }
        version
    }
}`

export const trimD1 = (str, n) => {
    const elements = str.split("#")
    const result = elements.slice(0, n).join("#")
    return result
}

export const archiveUser = async (pk, sk) => {
    try {
        return await API.graphql(graphqlOperation(deleteOccupant, {pk, sk}))
    } catch (e) {
        console.log('error: ', e)
        throw Error(e)
    }
}

export const saveUser = async (pk, sk, version, data) => {

    const _data = {
        pk: pk,
        sk: sk,
        version: version || 1,
        input: data
    }

    try {
        return await API.graphql(graphqlOperation(updateOccupant, _data))
    } catch (e) {
        console.log('error: ', e)
        throw Error(e)
    }
}

export const createUser = async (pk, sk, version, data) => {

    const _data = {
        pk: pk,
        sk: sk,
        version: version || 1,
        input: data
    }

    try {
        return await API.graphql(graphqlOperation(updateOccupant, _data))
    } catch (e) {
        console.log('error: ', e)
        throw Error(e)
    }
}

export const resetPassword = async (email) => {
    return new Promise(function (resolve, reject) {
        Auth.currentCredentials().then((credentials) => {
            let lambda = new Lambda({
                region: 'us-west-2',
                apiVersion: '2015-03-31',
                credentials: Auth.essentialCredentials(credentials),
            })

            let payload = `{"username": "${email}"}`

            let params = {
                FunctionName: `arn:aws:lambda:us-west-2:${process.env.REACT_APP_AWS_ACCOUNT_ID}:function:BSS-AdminResetUserPassword-${process.env.REACT_APP_STAGE}-${process.env.REACT_APP_AWS_ACCOUNT_ID}`,
                InvocationType: 'RequestResponse',
                Payload: payload,
            }

            lambda.invoke(params, (err, data) => {
                if (err) {
                    reject(err)
                } else {
                    resolve(data)
                }
            })
        })
    })
}

export const resendInvite = async (email) => {
    return new Promise(function (resolve, reject) {
        Auth.currentCredentials().then((credentials) => {
            let lambda = new Lambda({
                region: 'us-west-2',
                apiVersion: '2015-03-31',
                credentials: Auth.essentialCredentials(credentials),
            })

            let payload = `{"email": "${email}"}`

            let params = {
                FunctionName: `arn:aws:lambda:us-west-2:${process.env.REACT_APP_AWS_ACCOUNT_ID}:function:BSS-ResendUserInvite-${process.env.REACT_APP_STAGE}-${process.env.REACT_APP_AWS_ACCOUNT_ID}`,
                InvocationType: 'RequestResponse',
                Payload: payload,
            }

            lambda.invoke(params, (err, data) => {
                if (err) {
                    reject(err)
                } else {
                    resolve(data)
                }
            })
        })
    })
}

export const markTrainingComplete = async (trainingResult, playlist, user) => {

    let quizIds = []
    let videoIds = []

    playlist.sections.forEach((section) => {
        section.content.forEach((content) => {
            if (content.type == 'VIDEO')
                videoIds.push(content.id)
            if (content.type == 'QUIZ') {
                quizIds.push(content.id)
            }
        })
    })

    const _data = {
        pk: user.pk,
        sk: trainingResult.sk,
        expectedVersion: trainingResult.version || 1,
        input: {
            completedAt: Date.now(),
            updatedAt: Date.now(),
            createdAt: trainingResult.createdAt || Date.now(),
            sk: `TRAINING_RESULT#${playlist.pk}#COMPLETE`,
            quizzesCompleted: quizIds,
            videosCompleted: videoIds,
            title: trainingResult.playlistTitle,
            userType: trainingResult.userType || playlist.userType,
            certificateType: trainingResult.certificateType || playlist.certificateType,
            firstName: trainingResult.firstName || user.firstName,
            lastName: trainingResult.lastName || user.lastName,
            d2: trainingResult.d2 || user.d2,
            d1: trainingResult.d1 || user.d1.split("#").splice(0,5).join("#")
        }
    }
    //"d1": "c68a5e89-6121-40da-a8f7-ee376090ffc5#null#17c57993-89a9-45f3-8ae3-888796d5c834#71fa94fc-4bec-4455-95c8-12f65b0e02e8#be46d7e3-4a16-4fa8-88e1-fac0c896883a#ce6f9878-10a3-4583-8076-47513ff5002c",

    try {
        return await API.graphql(graphqlOperation(updateTraining, _data))
    } catch (e) {
        console.log('error: ', e)
        throw Error(e)
    }
}

export const expireTrainingResults = async (trainingResult) => {

    const _data = {
        pk: trainingResult.pk,
        sk: trainingResult.sk,
        expectedVersion: trainingResult.version,
        input: {
            completedAt: getTime(sub(Date.now(), { years: 1 })),
            sk: `TRAINING_RESULT#${trainingResult.sk.split('#')[1]}#EXPIRED`,
        }
    }

    try {
        return await API.graphql(graphqlOperation(updateTraining, _data))
    } catch (e) {
        console.log('error: ', e)
        throw Error(e)
    }
}

export const resetTrainingResult = async (result) => {

    const _data = {
        expectedVersion: result.version,
        input: {
            completedAt: null,
            sk: `TRAINING_RESULT#${result.sk.split('#')[1]}#IN_PROGRESS`,
            quizzesCompleted: [],
            updatedAt: Date.now(),
            videosCompleted: [],
        },
        pk: result.pk,
        sk: result.sk
    }

    try {
        return await API.graphql(graphqlOperation(updateTraining, _data))
    } catch (e) {
        console.log('error: ', e)
        throw Error(e)
    }
}

export const sendTrainingReminder = async ( user, playlist ) => {

    return new Promise(function (resolve, reject) {
        Auth.currentCredentials().then((credentials) => {
            let lambda = new Lambda({
                region: 'us-west-2',
                apiVersion: '2015-03-31',
                credentials: Auth.essentialCredentials(credentials),
            })

            let payload = `{"email": "${user.email}", "name": "${capitalizeEachWord(user.firstName)}", "playlist": "${playlist.playlistTitle[0].text}"}`

            let params = {
                FunctionName: `arn:aws:lambda:us-west-2:${process.env.REACT_APP_AWS_ACCOUNT_ID}:function:BSS-SendTrainingReminder-${process.env.REACT_APP_STAGE}-${process.env.REACT_APP_AWS_ACCOUNT_ID}`,
                InvocationType: 'RequestResponse',
                Payload: payload,
            }

            lambda.invoke(params, (err, data) => {
                if (err) {
                    reject(err)
                } else {
                    resolve(data)
                }
            })
        })
    })
}